// Shared formatting helpers for episode/audio display.

export const formatTime = (seconds) => {
  const s = Math.max(0, Math.floor(seconds || 0));
  const mins = Math.floor(s / 60);
  const secs = s % 60;
  return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-US', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

// "HH:MM:SS" or "MM:SS" → human-readable "1h 5m 30s" / "11m 26s"
export const formatDuration = (dur) => {
  if (!dur) return '';
  const parts = dur.split(':');
  if (parts.length === 3) {
    const h = parseInt(parts[0]);
    const m = parseInt(parts[1]);
    const s = parseInt(parts[2]);
    if (h > 0) return `${h}h ${m}m ${s}s`;
    return s > 0 ? `${m}m ${s}s` : `${m}m`;
  }
  return `${parseInt(parts[0])}m`;
};

// "HH:MM:SS" or "MM:SS" → total seconds
export const parseDurationToSeconds = (durationStr) => {
  if (!durationStr || typeof durationStr !== 'string') return 0;
  const parts = durationStr.split(':').map(p => parseInt(p));
  if (parts.some(isNaN)) return 0;
  if (parts.length === 2) return parts[0] * 60 + parts[1];
  if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
  return parts[0] || 0;
};

// episodes.json episode → the shape the audio context expects
export const normalizeEpisode = (ep) => ({
  id: ep.id,
  title: (ep.title || '').split('|')[0].trim(),
  audioUrl: ep.audioUrl || ep.enclosure?.url || '',
  imageUrl: ep.imageUrl || ep.image || '',
  durationSec: ep.durationSec ?? parseDurationToSeconds(ep.duration),
  pubDate: ep.pubDate,
});
